export default __webpack_public_path__ + "static/LGP Horizontal – Primary – 800x400-69080c5ca0bfcb083a8e2d0f3dc798af.svg";